import React from 'react'

import {
  annualLimits,
  annualUrl,
  freeLimits,
  usageBasedLimits,
} from './constants/Plans'

import PlanCard, {PlanType} from './PlanCard'

interface Props {
  influxdbURL: string
}

const PlanCards = ({influxdbURL}: Props): JSX.Element => {
  return (
    <div className="plan-cards">
      <PlanCard
        billingInfo="Billed monthly"
        buttonText="Upgrade Now"
        buttonURL="/checkout"
        description="I know my workload"
        icon={<div className="plan-cards--graphic plan-cards--graphic__payg" />}
        limitations={usageBasedLimits}
        planType={PlanType.UsageBased}
        title="Usage-Based"
      />
      <PlanCard
        billingInfo="No credit card required"
        buttonText="Keep"
        buttonURL={influxdbURL}
        description="I'm just trying this out"
        icon={
          <div className="plan-cards--graphic plan-cards--graphic__free plan-cards--focus" />
        }
        isHighlighted={true}
        limitations={freeLimits}
        planType={PlanType.Free}
        title="Free"
      />
      <PlanCard
        billingInfo="Yearly Contract"
        buttonText="Contact Sales"
        buttonURL={annualUrl}
        description="Enterprise scale"
        icon={
          <div className="plan-cards--graphic plan-cards--graphic__annual" />
        }
        limitations={annualLimits}
        openTab={true}
        planType={PlanType.Annual}
        title="Annual"
      />
    </div>
  )
}

export default PlanCards
